var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"clearfix"},[_c('compWrapper',{attrs:{"title":"商品品类","theme":"primary"}},[_c('componentNode',{staticClass:"margin-left-15 margin-top-15",on:{"on-data":_vm.getNodeData}})],1),_c('vLoading',{attrs:{"size":"large","transfer":"","loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }